import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AutomaticProductsFormValues } from '../schema/getAutomaticProductsFormSchema.ts';
import { useFormLocations } from './useFormLocations.ts';
import { useOrganization } from '@/clients/organization/useOrganization.ts';

export function useFormToggles(methods: UseFormReturn<AutomaticProductsFormValues>) {
    const { watch, unregister } = methods;
    const { clearLocations } = useFormLocations(methods);

    const [carrierOrganizationId, supplierOrganizationId] = watch(['carrierOrganizationId', 'supplierOrganizationId']);

    const { data: supplierOrganization } = useOrganization(
        typeof supplierOrganizationId === 'number' ? supplierOrganizationId : null
    );

    const handlePurchaseTransportToggle = useCallback(
        (checked: boolean) => {
            if (checked) {
                if (carrierOrganizationId && typeof carrierOrganizationId === 'number') {
                    clearLocations(carrierOrganizationId);
                    unregister('carrierOrganizationId');
                }
                if (supplierOrganizationId) {
                    const isValidMerchantSupplier = supplierOrganization?.types.includes('carrier');
                    if (!isValidMerchantSupplier) {
                        clearLocations(supplierOrganizationId);
                        unregister('supplierOrganizationId');
                    }
                }
            }
        },
        [carrierOrganizationId, supplierOrganizationId, supplierOrganization, unregister, clearLocations]
    );

    return { handlePurchaseTransportToggle };
}
